import React, { Component } from 'react';
import PlatformSidebar from './PlatformSidebar';
import Onboarding from './Onboarding.js';
import AddFunds from './AddFunds.js';
import ImportFromPassword from './ImportFromPassword';
import MarketplaceFeaturedAuction from './MarketplaceFeaturedAuction';
import PurchasedNFT from './PurchasedNFT';
import * as encryptUtils from './encryptDecryptUtils';
import * as scriptUtils from './utils/scriptUtils';
import * as loggingUtils from './utils/loggingUtils';
import './Marketplace.css';

class Marketplace extends Component {
  constructor(props) {
    super(props);
    this.changeTabs = this.changeTabs.bind(this);
    this.onClickNFT = this.onClickNFT.bind(this);
    this.selectModal = this.selectModal.bind(this);

    this.state = {
      isLoading: true,
      mintableSongs: [],
      mintableVideos: [],
      modalShown: '',
      shownTab: 'audio',
    }
  }

  async componentDidMount() {
    let mintableVideos = await encryptUtils.getMintReadyNFTs(["0"]);
    for(let i = 0; i < mintableVideos.length; i++) {
      let item = mintableVideos[i];
      let rawAddress = item["creatorAddress"];
      if(rawAddress != null) {
        rawAddress = rawAddress.substring(0, 5) + "..." + rawAddress.substring(rawAddress.length - 5)
        item["displayedCreatorAddress"] = rawAddress;
        item["creatorProfileImage"] = scriptUtils.getProfileImage(item["creatorAddress"]);
      }
      mintableVideos[i] = item;
    }
    this.setState({
      mintableVideos,
    });

    let mintableSongs = await encryptUtils.getMintReadyNFTs(["1"]);
    for(let i = 0; i < mintableSongs.length; i++) {
      let item = mintableSongs[i];
      let rawAddress = item["creatorAddress"];
      if(rawAddress != null) {
        rawAddress = rawAddress.substring(0, 5) + "..." + rawAddress.substring(rawAddress.length - 5)
        item["displayedCreatorAddress"] = rawAddress;
        item["creatorProfileImage"] = scriptUtils.getProfileImage(item["creatorAddress"]);
      }
      mintableSongs[i] = item;
    }
    this.setState({
      mintableSongs,
    });

    for(let i = 0; i < mintableVideos.length; i++) {
      let item = mintableVideos[i];
      item["displayedCreatorAddress"] = await encryptUtils.getENS(item["creatorAddress"]);
      mintableVideos[i] = item;
    }
    this.setState({
      mintableVideos,
    });

    for(let i = 0; i < mintableSongs.length; i++) {
      let item = mintableSongs[i];
      item["displayedCreatorAddress"] = await encryptUtils.getENS(item["creatorAddress"]);
      mintableSongs[i] = item;
    }
    this.setState({
      mintableSongs,
      isLoading: false,
    });
    loggingUtils.logEvent(
      this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
      'marketplace',
      'marketplace_page_load',
      'info',
      "https://the402.xyz",
      {},
    );
  }

  changeTabs(shownTab) {
    this.setState({
      shownTab,
    });
    loggingUtils.logEvent(
      this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
      'marketplace',
      'marketplace_change_load',
      'info',
      "https://the402.xyz",
      {
        tab: shownTab
      },
    );
  }

  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  onClickNFT(item) {
    loggingUtils.logEvent(
      this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
      'marketplace',
      'marketplace_click_nft',
      'info',
      "https://the402.xyz",
      {
        item: item
      },
    );
    window.location.href = window.location.origin + "/marketplace/" + item.authUUID + "?protocol=" + item.protocol;
  }

  render() {
    let items = this.state.shownTab === "audio" ? this.state.mintableSongs : this.state.mintableVideos;
    return (
      <div className="flex-col sm:flex min-h-screen">
        <div>
          <PlatformSidebar
            modalShown={this.state.modalShown}
            selectModal={this.selectModal}
          />
        </div>
        <div className="h-16 sm:min-h-screen sm:justify-start sm:border-r-2 dark:border-zinc-800 border-b dark:border-b-2 w-screen justify-center sm:mt-0 flex sm:flex-col sm:w-48 fixed top-16 sm:bottom-0 dark:bg-custom-black bg-custom-white">
          <div
            className={
              this.state.shownTab === 'audio'
                ?
              "ml-10 mt-4 font-semibold text-gray-800 dark:text-gray-100 cursor-pointer"
                :
              "ml-10 mt-4 font-medium text-gray-600 dark:text-gray-400 cursor-pointer"
            }
            onClick={() => this.changeTabs("audio")}
          >
            Music
          </div>
          <div
            className={
              this.state.shownTab === 'video'
                ?
              "ml-10 mt-4 font-semibold text-gray-800 dark:text-gray-100 cursor-pointer"
                :
              "ml-10 mt-4 font-medium text-gray-600 dark:text-gray-400 cursor-pointer"

            }
            onClick={() => this.changeTabs("video")}
          >
            Videos
          </div>
        </div>
        <div className = "flex-col items-center sm:ml-48 mt-16 justify-center">
          {
            this.state.shownTab === 'video'
              ?
            <div className="marketplace-AuctionsContainer">
              {
                this.state.mintableVideos.slice(0, 1).map((mintableVideo, ind) => {
                  return (
                    <div>
                    {/*
                    <MarketplaceFeaturedAuction
                      key={ind}
                      item={mintableVideo}
                    />
                    */}
                    </div>
                  );
                })
              }
            </div>
              :
            <div className = "marketplace-AuctionsContainer">
              {
                this.state.mintableSongs.slice(0, 1).map((mintableSong, ind) => {
                  return (
                    <div>
                    {/*
                    <MarketplaceFeaturedAuction
                      key={ind}
                      item={mintableSong}
                    />
                    */}
                    </div>
                  );
                })
              }
            </div>
          }
          {
            items.length === 0 && !this.state.isLoading
              ?
            <div className="w-full h-screen flex justify-center items-center text-5xl text-black dark:text-white">
              No Collections Yet
            </div>
              :
            <div className = "flex justify-around">
              <div className="mt-20 sm:mt-0 grid grid-cols-1 xl:grid-cols-4 xl:gap-4 lg:grid-cols-2 lg:gap-4">
                {
                  items.map(item => {
                    return (
                      <PurchasedNFT
                        key={item.authUUID}
                        image={item.imagePinata}
                        name={item.name.split("_").join(" ")}
                        address={item.displayedCreatorAddress}
                        addressImage={item.creatorProfileImage}
                        handleItemClick={() => this.onClickNFT(item)}
                        handleCTAClick={() => this.onClickNFT(item)}
                        ctaText="Buy"
                      />
                    );
                  })
                }
              </div>
            </div>
          }
        </div>
        {
          this.state.modalShown === 'createAccount'
            ?
          <Onboarding selectModal={this.selectModal} />
            :
          this.state.modalShown === 'addFunds'
            ?
          <AddFunds selectModal={this.selectModal} />
            :
          this.state.modalShown === 'importFromPassword'
            ?
          <ImportFromPassword selectModal={this.selectModal} />
            :
          null
        }
      </div>
    );
  }
}

export default Marketplace;
